// Auto-scrolls to top whenever the route pathname changes — except when the
// destination URL has a hash, in which case we smooth-scroll to that anchor.
// Mounted once inside the Router in App.js.
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.replace(/^#/, ""));
      if (el) {
        // Defer so the destination route has rendered.
        setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 60);
        return;
      }
    }
    // Default: jump cleanly to the top of the new page.
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);

  return null;
}
